<template>

	<div>
		<b-card>
			<b-row>					
				<b-col cols="12" class="mb-1">
					<h5>Filtros</h5>
				</b-col>
				
				<b-col sm="12" md="6"  v-if="$can('all', 'manage')">
					<label>Clientes</label>
					<v-select 
					v-model="filterCustomer"
					:options="optionsCustomer" />
				</b-col>
				<b-col sm="12" md="6">
					<label>Estado</label>
					<v-select 
					v-model="filterStatus"
					:options="optionsStatus" />
				</b-col>
			</b-row>
		</b-card>
		

		<!-- Table Container Card -->
		<b-card
			no-body
			class="mb-0"
		>
			<div class="m-2">				
				
				<!-- Table Top -->
				<b-row>
					<!-- Per Page -->
					<b-col
						md="4"
						class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
					>
						<label>Mostrar</label>
						<v-select
							v-model="perPage"
							:dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
							:options="perPageOptions"
							:clearable="false"
							class="per-page-selector d-inline-block mx-50"
						/>
						<label>registros</label>
					</b-col>

					<!-- Search -->
					<b-col
						md="8"
						class="d-flex align-items-center justify-content-end mb-1 mb-md-0"
					>
						<b-form-input
							v-model="searchQuery"
							class="d-inline-block mr-1 col-6"
							placeholder="Buscar..."
						/>
					</b-col>
				</b-row>

			</div>

			<b-table
				ref="refUserListTable"
				class="position-relative"
				:items="fetchCoursesQualifications"
				responsive
				:fields="tableColumns"
				primary-key="id"
				:sort-by.sync="sortBy"
				show-empty
				empty-text="No matching records found"
				:sort-desc.sync="isSortDirDesc"
			>
				<!-- Column: User -->
                <template #cell(access.fullName)="data">												
					<b-media vertical-align="center">
                        <template #aside>
                            <b-avatar
                                size="32"
                                :src="avatarSrc(data.item.access.photo)"
								:text="avatarText(data.item.access.fullName)"
                                variant="light-success"
                                :to="{ name: 'users-edit', params: { id: data.item.id } }"
                            />
                        </template>
                        <b-link
                            :to="{ name: 'users-edit', params: { id: data.item.id } }"
                            class="font-weight-bold d-block text-nowrap">
                            {{ data.item.access.fullName }}
                        </b-link>
                    </b-media>														
                </template>
				
				<!-- Column: Curso -->
				<template #cell(user_cq.course_cq)="data">         
					<b-col 
						v-for="(i, index) in data.item.user_cq"
						:id="i.id"
						:key="index"                             
					>	
						<hr v-if="index > 0" style="border-color: transparent">				
						<b-link
							:to="{ name: 'courses-edit', params: { id: i.course_cq.id }, query: { tab: '0' } }"
							class="font-weight-bold d-block text-nowrap"
						>
							{{i.course_cq.name}}
						</b-link>	
					</b-col>
                </template>
				
				<!-- Column: Score -->
				<template #cell(user_cq.grade)="data">         
					<b-col 
						v-for="(i, index) in data.item.user_cq"
						:id="i.id"
						:key="index"                             
					>					
						<hr v-if="index > 0" style="border-color: transparent">				
						{{i.grade}}
					</b-col>
                </template>
				
				<!-- Column: Estado -->
				<template #cell(user_cq.state)="data">
                    <b-col 
						v-for="(i, index) in data.item.user_cq"
						:id="i.id"
						:key="index"                             
					>			
						<hr v-if="index > 0" style="border-color: transparent">					
						<b-badge variant="light-success" v-if="i.state == 1">
							Aprobado
						</b-badge>
						<b-badge variant="light-danger" v-else>
							Desaprobado
						</b-badge>			
					</b-col>
                </template>
								
				<!-- Column: Cliente -->
				<template #cell(customer.name)="data">					
					{{ data.item.customer.name }}             										
                </template>
				
			</b-table>
			<div class="mx-2 mb-2">
				<b-row>

					<b-col
						cols="12"
						sm="6"
						class="d-flex align-items-center justify-content-center justify-content-sm-start"
					>
						<span class="text-muted">Mostrando {{ dataMeta.from }} al {{ dataMeta.to }} de {{ dataMeta.of }} registros</span>
					</b-col>
					<!-- Pagination -->
					<b-col
						cols="12"
						sm="6"
						class="d-flex align-items-center justify-content-center justify-content-sm-end"
					>

						<b-pagination
							v-model="currentPage"
							:total-rows="totalUsers"
							:per-page="perPage"
							first-number
							last-number
							class="mb-0 mt-1 mt-sm-0"
							prev-class="prev-item"
							next-class="next-item"
						>
							<template #prev-text>
								<feather-icon
									icon="ChevronLeftIcon"
									size="18"
								/>
							</template>
							<template #next-text>
								<feather-icon
									icon="ChevronRightIcon"
									size="18"
								/>
							</template>
						</b-pagination>

					</b-col>

				</b-row>
			</div>
		</b-card>
	</div>
</template>

<script>
	import { useToast } from 'vue-toastification/composition';
	import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';
	import {
		BCard, BCardText, BRow, BCol, BFormInput, BButton, BTable, BMedia, BAvatar, BLink,
		BBadge, BDropdown, BDropdownItem, BPagination,  
	} from 'bootstrap-vue'
	import vSelect from 'vue-select'
	import store from '@/store'
	import { ref, onUnmounted, reactive, watch } from '@vue/composition-api'
	import { avatarText } from '@core/utils/filter'
	import useCoursesQualificationsList from './useCoursesQualificationsList'
	import courseStoreModule from '../courseStoreModule'
	import QualificationListFilters from './CoursesQualificationsListFilters.vue'
	import axios from 'axios'
	
	export default {
		components: {

			BCard,
            BCardText,
			BRow,
			BCol,
			BFormInput,
			BButton,
			BTable,
			BMedia,
			BAvatar,
			BLink,
			BBadge,
			BDropdown,
			BDropdownItem,
			BPagination,
			QualificationListFilters,

			vSelect,
		}, 
		methods: {
            avatarSrc (img){
                if (img){
                    if (img.includes('http')){
                        return img;
                    } else {
                        if (process.env.VUE_APP_ENVIROMENT == 'development'){
                            return require(`@/assets/images/modules/users/${img}`);
                        } else {
                            return `${process.env.VUE_APP_FILES}/modules/users/${img}`;
                        }
                    }
                } else {
                    return null;
                }
            }
		},
		setup() {			
			const USER_APP_STORE_MODULE_NAME = 'app-user';
			
			// Register module
			if (!store.hasModule(USER_APP_STORE_MODULE_NAME)) store.registerModule(USER_APP_STORE_MODULE_NAME, courseStoreModule);
			// UnRegister on leave
			onUnmounted(() => {
				if (store.hasModule(USER_APP_STORE_MODULE_NAME)) store.unregisterModule(USER_APP_STORE_MODULE_NAME)
			});		
			
			
			const {
				fetchCoursesQualifications,
				tableColumns,
				perPage,
				currentPage,
				totalUsers,
				dataMeta,
				perPageOptions,
				searchQuery,
				sortBy,
				isSortDirDesc,
				refUserListTable,
				refetchData,
				
				filterStatus,
				filterCustomer,
				
			} = useCoursesQualificationsList();
			
			const optionsCustomer = reactive([]);
			const optionsStatus = reactive([
				{ label: 'Desaprobado', value: 0 },			
				{ label: 'Aprobado', value: 1 },		
			]);
			
			axios.get(`${process.env.VUE_APP_HOST}/api/dashboard/courses/qualificationsFilter`)
			.then(response => {		
								
				response.data.map( item => {
					optionsCustomer.push({
						label : item.name, 
						value : item.id
					});
				});
				
			});	
									
			return {

				fetchCoursesQualifications,
				tableColumns,
				perPage,
				currentPage,
				totalUsers,
				dataMeta,
				perPageOptions,
				searchQuery,
				sortBy,
				isSortDirDesc,
				refUserListTable,
				refetchData,

				avatarText,	
						
				filterStatus,
				filterCustomer,
				optionsCustomer,
				optionsStatus,
			}
		},
	}
</script>

<style lang="scss" scoped>
	.media{
		align-items: center;
	}
	.per-page-selector {
		width: 90px;
	}
</style>

<style lang="scss">
	@import '@core/scss/vue/libs/vue-wizard.scss';
	@import '@core/scss/vue/libs/vue-select.scss';
</style>
